import {useSelector} from 'react-redux';

export default function useCurrentPersona() {
  return useSelector((state) => state.session.currentPermissions);
}
